import api from "@/shared/api/api";
import type {
  GetFinancialOverviewSummaryParams,
  FinancialOverviewSummaryResponse,
} from "../types";

const BASE = "/v1/admin/creators/financial-overview";

function buildSummaryParams(
  params?: GetFinancialOverviewSummaryParams
): URLSearchParams | undefined {
  if (!params) return undefined;
  const usp = new URLSearchParams();
  if (params.creatorIds?.length) {
    for (const id of params.creatorIds) usp.append("creatorIds", id);
  }
  if (params.creatorName) usp.set("creatorName", params.creatorName);
  if (params.currency) usp.set("currency", params.currency);
  if (params.dateFrom) usp.set("dateFrom", params.dateFrom);
  if (params.dateTo) usp.set("dateTo", params.dateTo);
  if (params.status?.length) {
    for (const s of params.status) usp.append("status", s);
  }
  return usp.toString().length ? usp : undefined;
}

export const adminFinancialOverviewApi = {
  summary: async (
    params?: GetFinancialOverviewSummaryParams,
    signal?: AbortSignal
  ): Promise<FinancialOverviewSummaryResponse> => {
    return api<FinancialOverviewSummaryResponse>({
      url: `${BASE}/summary`,
      method: "GET",
      params: buildSummaryParams(params),
      signal,
    });
  },
};
